import { render, staticRenderFns } from "./AssignsList.vue?vue&type=template&id=050dfb95&lang=pug&"
import script from "./AssignsList.vue?vue&type=script&lang=js&"
export * from "./AssignsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports